/**
 * Instantiate MobileNavigation
 * @param  {Node}       wrapper Dom class or dom node
 * @param  {Object}     options Object holding optional parameters
 * @return {undefined}
 */
export default class MobileNavigation {
	constructor({ burger, overlay, menu, options = {} }) {
		this.burgerDOM = document.querySelector(burger)
		this.overlayDOM = document.querySelector(overlay)
		this.menuDOM = document.querySelector(menu)

		this._bindEvents()
	}

	_bindEvents() {
		this.burgerDOM.addEventListener("click", () => this._activate());
		// this.itemsDOM.forEach(item => item.addEventListener("click", this.boundActivateEvent))
	}

	_activate(event) {
		if (this.burgerDOM.classList.contains("is-active")) {
			this.burgerDOM.classList.remove("is-active");
			if (this.overlayDOM) this.overlayDOM.classList.remove("is-active");
			this.menuDOM.classList.remove("is-active");
		} else {
			this.burgerDOM.classList.add("is-active");
			if (this.overlayDOM) this.overlayDOM.classList.add("is-active");
			this.menuDOM.classList.add("is-active");
		}
	}
}
